import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class SupplyCartBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SUPPLY_CART;
}

export default SupplyCartBuildingTileEntity;
